export default __webpack_public_path__ + "static/media/640_dummy2016-heilpraxis01-mobile-de.be9a9133.png";